import React from 'react'
import { Link } from 'react-router-dom'
import './Theme.css'

const ThemeUI = ({context, onThemeClick}) =>
  <React.Fragment>
    {
      ['lite', 'dark'].filter(theme => theme !== context.theme).map((theme, i) =>
        <Link key={i} className='com_theme'
          to={'?theme=' + theme} data-theme={theme} onClick={onThemeClick}>
        </Link>
      )
    }
  </React.Fragment>

export default ThemeUI
